<template>
  <grid
    ref="grid"
    :config="gridConfig"
    class="no-grid-border"
    @handleCustomButtonGrid="handlerAddToRFQ3"
  />
</template>

<script>
import _gridConfig from './GridConfig'
import { waitValue } from '@/utils/promises'

export default {
  name: 'StocksGridIndex',
  components: {
    'grid': () => import(/* webpackChunkName: 'Grid' */ '@/components/Grid/Index')
  },
  props: {
    isPreview: { type: Boolean, default: false },
    data: { type: Object }
  },
  watch: {
    'data': {
      immediate: true,
      handler () {
        let { partID } = this.data || {}
        if (!partID) return
        return this.getGrid()
          .then((grid) => {
            let filters = `partID == ${partID}`
            grid.setFilters(filters)
            grid.loadData()
          })
      }
    }
  },
  computed: {
    gridConfig () {
      return _gridConfig({ isPreview: this.isPreview })
    }
  },
  methods: {
    getGrid () {
      return waitValue(() => this.$refs['grid'])
    },
    modelRFQ3 () {
      return {
        rfqid: null,
        quoteDate: new Date(),
        partID: null,
        partSN: '',
        qty: 1,
        conditionID: null,
        price: null,
        currencyID: null,
        traceabilityCompanyID: null,
        tagInfoCompanyID: null,
        tagDate: null,
        releaseID: null
      }
    },
    handlerAddToRFQ3 ({ row }) {
      let data = this.copyObjectProps(this.modelRFQ3(), { ...this.data, ...row })
      this.$emit('add-to', data)
    }
  }
}
</script>
